import launchScoreboard from './launchScoreboard';

export default launchScoreboard;
